import questionMark from "./../../assets/images/Vector.svg";
interface Props {
  buttonHandler: () => void;
}
export const QuestionMarkButton = ({ buttonHandler }: Props) => (
  <button onClick={() => buttonHandler()} className="modal_button">
    <img className="modal_question" src={questionMark} alt="" />
  </button>
);
